
import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( ( theme, props ) => {

	return {
		headerContainer: {
			padding: "0.25rem 0rem",

			[rooterMediaQuery.mobileAndTablet]: {
				padding: "0.25rem 1rem"
			}
		},
		rootContainer: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "space-between",
			paddingLeft    : props?.theatreModeToggle ? "1rem" : 0
		},
		creatorContainer: {
			padding: "0.8rem 0"
		},
		leftMargin: {
			marginLeft: "1rem"
		},
		avatarTheatre : { ...theme.other.rooterAvatars.size40 },
		avatar        : {
			width  : "4rem",
			height : "4rem"
		},
		nameCtn: {
			display       : "flex",
			flexDirection : "column"
			// gap           : "0.5rem"
		},
		img: {
			...theme.other.responsiveImage,
			...theme.other.rooterAvatars.borderRadius,
			width        : "100%",
			height       : "unset",
			borderRadius : "50%"
		},
		verifiedIconContainer: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "start",
			// lineHeight : 0,
			cursor         : "pointer"
		},
		svgIcon: {
			...theme.other.svgIcons.size20,
			cursor    : "pointer",
			transform : "scale(0.7)",
			marginTop : "0.4rem"
		},
		verifiedUsers: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "center",
			paddingLeft    : "0.4rem",
			margin         : "-0.4rem"
		},
		followBtn: {
			fontWeight: 500
		},
		userFollowButton: {
			textTransform : "initial",
			background    : "linear-gradient(to right, #439aff, #126bd5)",
			padding       : "0rem 2.8rem",
			height        : "30px",
			boxShadow     : "none ! important",
			borderRadius  : "10px",

			"&.disabled": {
				opacity : "0.5",
				cursor  : "initial"
			}
		},
		streamerFollowersStyleDark: {
			fontSize: "1.3rem"
			// marginTop : "0.25rem"
		},
		streamerFollowersTheatre: {
			fontSize: "11px"
			// marginTop : "0.25rem"
		},
		svgShareIcon: {
			width  : "25px",
			height : "25px",
			filter : theme.other.darkMode ? "none" : "invert(1)"
		},
		shareBtnContainer: {
			display       : "flex",
			flexDirection : "row",
			alignItems    : "center",
			cursor        : "pointer"
		},
		share: {
			fontSize      : "12px",
			fontWeight    : "500",
			color         : "#fff",
			margin        : "0px",
			textTransform : "none"
		},
		broadcasterName: {
			fontWeight: "500"
		},
		unfollowButton: {
			backgroundColor: theme.other.darkMode ? theme.other.paletteNew.secondaryDarkGrey50 : theme.other.paletteNew.secondaryLightGrey,

			"&:hover": {
				backgroundColor: theme.other.darkMode ? theme.other.paletteNew.secondaryDarkGrey50 : theme.other.paletteNew.secondaryLightGrey
			},

			"&.disabled": {
				opacity : "0.5",
				cursor  : "initial"
			}

		},
		unfollowButtonText: {
			color      : !theme.other.darkMode ? `${ theme.other.colors.text.secondary } !important` : "rgb(255, 255, 255) !important",
			fontWeight : "500"
			// fontSize : "13px !important"
		}
	};
} );

